<template>
  <div class="main-component news-activity">
    <div class="wrap">
      <header class="wow1 fadeInUp1" data-wow-duration1="1s">
        <template v-if="dataItems.length > 0">自由贸易协定信息看板</template>
      </header>
      <div class="content-wrap">
        <div class="first wow1 fadeInUp1" data-wow-duration1="1s" data-wow-delay1="0.5s">
          <div class="time"><template v-if="dataItems[0]">{{dataItems[0].publishTime }}</template></div>
          <div class="title"><template v-if="dataItems[0]">{{dataItems[0].title}}</template></div>
          <div class="desc"><template v-if="dataItems[0]">{{$options.filters.removeTag(dataItems[0].content)}}</template></div>
          <template v-if="dataItems[0]">
            <img :src="dataItems[0].bannerImage || dataItems[0].coverImage" class="cover" v-if="dataItems[0].bannerImage || dataItems[0].coverImage">
          </template>
          <router-link :to="{name: 'NewsShow', params: {id: dataItems[0]? dataItems[0].id : ''}}" class="btn thm-btn wow fadeInUp"  data-wow-duration="1s" data-wow-delay="1s"><span >查看</span></router-link>
        </div>
        <div class="list wow1 animate__animated1 animate__fadeInRight1" data-wow-duration1="1s" data-wow-delay1="1s" v-if="dataItems.length > 1">
          <div class="news-item" v-for="(item, index) in list" :key="index" @click="$router.push({name: 'NewsShow', params: {id: item.id}})">
            <div class="f1"></div>
            <div class="f2">
              <div class="title">{{item.title}}</div>
              <div class="desc">{{item.content | removeTag}}</div>
            </div>
            <div class="f3">{{item.publishTime }}</div>
          </div>
        </div>
        <div class="more-btn" @click="$router.push({name: 'News'})">查看更多新闻</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeNews',
  props: {
    dataItems: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  computed: {
    list () {
      return this.dataItems.slice(1, 5)
    }
  }
}
</script>

<style scoped>
.main-component{
  text-align: center;
}
.content-wrap{
  padding-left: 500px;
  position: relative;
  height: 550px;
  overflow: hidden;
  margin-top: 45px;
}
.more-btn:hover{
  border-color: #ffa000;
  color: #ffa000;
}
.first{
  width: 445px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f5f9ff;
  padding: 35px 30px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.first .time{
  color: #999;
  font-size: 14px;
  margin-bottom: 20px;
}
.first .title{
  white-space: normal;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.first .desc{
  white-space: normal;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #666;
  margin-bottom: 25px;
}
.first .cover{
  width: 283px;
  margin-bottom: 30px;
}
.news-item{
  padding: 20px 0;
  border-top: 1px solid #ddd;
  cursor: pointer;
  position: relative;
  padding-left: 50px;
  padding-right: 140px;
}
.news-item:last-child{
  border-bottom: 1px solid #ddd;
}
.news-item .f1{
  position: absolute;
  width: 6px;
  height: 6px;
  left: 20px;
  top: 28px;
  background-color: #333;
  border-radius: 100%;
}
/* .news-item:first-child .f1, */
.news-item:hover .f1{
  /* background-color: #1F8AFD; */
  background-color: #ffa000;
}
.news-item .f3{
  position: absolute;
  right: 5px;
  top: 22px;
  color: #999;
  font-size: 14px;
}
/* .news-item:first-child .f3, */
.news-item:hover .f3 {
  /* color: #1F8AFD; */
  color: #ffa000;
}
.news-item .title{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}
/* .news-item:first-child .title, */
.news-item:hover .title{
  /* color: #1F8AFD; */
  color: #ffa000;
}
.news-item .desc {
  white-space: normal;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #666;
  text-align: left;
}
.btn{
  display: block;
  width: 136px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background-color: #1F8AFD;
  border-radius: 3px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn span{
  color: #fff;
}
.thm-btn{
  
}
.more-btn{
  width: 160px;
  font-size: 16px;
  padding: 5px 0;
  margin: 25px auto 0;
  border-radius: 30px;
  border: 1px solid #1F8AFD;
  color: #1F8AFD;
  cursor: pointer;
}
header{
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/home/News.vue